/* global requirejs */
import get from "lodash/get";

import {
  asosGlobalNamespace,
  manifestWindowKey,
  featureManifestWindowKey
} from "@template/constants";

export const getFeaturesFromWindowManifest = () => {
  if (get(window, `[${asosGlobalNamespace}][${manifestWindowKey}]`)) {
    const manifest = window[asosGlobalNamespace][manifestWindowKey];

    const features = {
      features: manifest.features || {},
      mvt: manifest.mvt || {}
    };

    return features;
  }
  return {};
};

export const getFeatureManifest = () =>
  window[asosGlobalNamespace][featureManifestWindowKey] ||
  /* backward compatibility */ window.__featureManifest;

export const initialise = context =>
  new Promise(resolve => {
    requirejs(["asos-web-features"], ({ default: features }) => {
      const instance = features.getInstance(getFeatureManifest(), context);
      resolve(instance);
    });
  });

export const addManifestFeatures = instance => {
  return instance.addManifest({ ...getFeaturesFromWindowManifest() });
};
